import { momentLocalizer, Calendar } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import moment from "moment";
import { useEffect, useState, useCallback, useMemo } from "react";
import {
    Dialog,
    DialogTitle,
    IconButton,
    Typography,
    Box,
    Chip,
    Button,
    Tooltip,
    Card,
    CardContent,
    Divider,
    TextField
} from "@mui/material";
import {
    Close,
    EventAvailable,
    Schedule,
    Person,
    Room as RoomIcon,
    AccessTime
} from "@mui/icons-material";
import axios from "axios";
import { successToast } from "helpers/Notification";
import { errorToast } from "helpers/Notification";
import FormDialog from "helpers/FormDialog";
import SelectEmployee from "helpers/SelectEmployee";

const calendarStyles = {
    height: '100%',
    '& .rbc-event-label': {
        display: 'none'
    },
    '& .rbc-toolbar .rbc-btn-group:first-child button:nth-of-type(2)': {
        display: 'none'
    },
};

const ViewAllRoomsCalendar =
    // (props, linemanager)
    (props) => {
        const [showModal, setShowModal] = useState(false);
        const [showEventModal, setShowEventModal] = useState(false);
        const [selectedEvent, setSelectedEvent] = useState(null);
        const [list, setList] = useState([]);
        const [info, setInfo] = useState();
        const [showFormDialog, setShowFormDialog] = useState(false);
        const [availableRooms, setAvailableRooms] = useState([]);
        const [formData, setFormData] = useState({});
        const [participants, setParticipants] = useState([]);
        const [otherOpen, setOtherOpen] = useState(false);
        const [otherEditObject, setOtherEditObject] = useState(null);
        const [otherForm, setOtherForm] = useState({ names: '', phone: '', email: '', category: '' });
        const [isSelectRecipientOpen, setIsSelectRecipientOpen] = useState(false);
        const [value, setValue] = useState({});
        const [meetingTypes, setMeetingTypes] = useState([]);


        const { height, fetchDetailsContent, employees } = props;

        const handleSelectRecipients = (selectedEmployees) => {
            let updatedRecipients = selectedEmployees;
            setParticipants(updatedRecipients);
            setIsSelectRecipientOpen(false);
        };

        const openOtherModal = (editObj = null) => {
            if (editObj) {
                setOtherEditObject(editObj);
                setOtherForm({ names: editObj.names || '', phone: editObj.phone || '', email: editObj.email || '', category: editObj.category || editObj.title || '' });
            } else {
                setOtherEditObject(null);
                setOtherForm({ names: '', phone: '', email: '', category: '' });
            }
            setOtherOpen(true);
        };

        const handleCloseOther = () => {
            setOtherOpen(false);
            setOtherEditObject(null);
            setOtherForm({ names: '', phone: '', email: '', category: '' });
        };

        const submitOtherParticipant = (data) => {
            // data contains names, phone, email, title/category
            const newObj = {
                id: otherEditObject ? otherEditObject.id : Date.now(),
                names: data.names,
                phone: data.phone || '',
                email: data.email || '',
                category: data.title || data.category || '',
                isOther: true
            };

            if (otherEditObject) {
                // replace existing
                setParticipants(prev => prev.map(p => (p.id === otherEditObject.id ? newObj : p)));
            } else {
                setParticipants(prev => [...prev, newObj]);
            }
            handleCloseOther();
        };

        const removeOtherParticipant = (id) => {
            setParticipants(prev => prev.filter(p => p.id !== id));
        };
        useEffect(() => {
            const fetchMeetingTypes = async () => {
                try {
                    const response = await axios.get("/api/meeting/type/list");
                    // console.log("Meeting types response: ", response);
                    if (response.status === 200) {
                        setMeetingTypes(response.data?.data?.data || []);
                    }
                } catch (error) {
                    console.error("Error fetching meeting types:", error);
                }
            };
            fetchMeetingTypes();
        }, []);
        useEffect(() => {
            // console.log("employees---: ", employees)
        }, [employees])

        // Configure moment to start week from Monday
        moment.updateLocale('en-GB', {
            week: {
                dow: 1, // Monday is the first day of the week
                doy: 4  // First week of the year must contain 4 January (ISO week)
            }
        });
        moment.locale("en-GB");
        const localizer = momentLocalizer(moment);

        const DnDCalendar = withDragAndDrop(Calendar);

        const statusColors = {
            'completed': '#4caf50',
            'ongoing': '#ff9800',
            'scheduled': '#2196f3',
            'cancelled': '#f44336',
            'default': '#757575'
        };

        const setValue0 = (name, val) => {
            if (!name) {
                return null;
            }

            setValue(v => {
                v[name] = val;
                return { ...v };
            });
        }

        const getStatusColor = (status) => {
            return statusColors[status?.toLowerCase()] || statusColors.default;
        };

        const dataSummary = useCallback(async () => {
            const resp = await fetchDetailsContent("api/room/calendars/all");
            // console.log("Meetings calendar: ", resp);
            if (resp?.data.calendar && resp?.data.calendar.length > 0) {
                setList(
                    resp?.data.calendar?.map((value) => ({
                        allDay: false,
                        start: new Date(value?.start),
                        end: new Date(value?.end),
                        venue: value?.venue,
                        Room: value?.Room,
                        participants: value?.MeetingParticipants,
                        resource: {
                            id: value?.id,
                            name: value?.name,
                            type: value?.type,
                            venue: value?.venue,
                            duration: value?.duration,
                            status: value?.status,
                            agenda: value?.agenda,
                            createdBy: value?.createdBy,
                            room: value?.Room,
                        }
                    })) || []
                );

            }
        }, [fetchDetailsContent]);

        // Handle event drag and drop
        const onEventDrop = async ({ event, start, end }) => {
            try {
                const updatedList = list.map(item => {
                    if (item.resource.id === event.resource.id) {
                        return {
                            ...item,
                            start: start,
                            end: end
                        };
                    }
                    return item;
                });
                setList(updatedList);

                const updateData = {
                    name: event.resource.name,
                    // start: start.toISOString().slice(0, 16),
                    // end: end.toISOString().slice(0, 16),
                    start: moment(start).format('YYYY-MM-DDTHH:mm'),
                    end: moment(end).format('YYYY-MM-DDTHH:mm'),
                };

                const response = await axios.put(`api/meeting/update/duration/${event.resource.id}`, updateData);

                if (response.status === 200 || response.status !== 201) {
                    // setList(list);
                    successToast("Meeting time updated successfully");
                    // show a toast notification here
                }
                else {
                    errorToast("Can't update meeting time")
                }
            } catch (error) {
                errorToast(error?.data?.message || "Failed to update meeting time");
                console.error('Error updating meeting time:', error);
                // show a toast notification here
            }
        };

        const onEventResize = async ({ event, start, end }) => {
            try {
                const updatedList = list.map(item => {
                    if (item.resource.id === event.resource.id) {
                        return {
                            ...item,
                            start: start,
                            end: end
                        };
                    }
                    return item;
                });
                setList(updatedList);

                const updateData = {
                    name: event.resource.name,
                    start: moment(start).format('YYYY-MM-DDTHH:mm'),
                    end: moment(end).format('YYYY-MM-DDTHH:mm'),
                };
                const response = await axios.put(`api/meeting/update/duration/${event.resource.id}`, updateData);

                if (response.status === 200 && response.status !== 201) {
                    successToast("Meeting time updated successfully");
                    console.error('Failed to update meeting time:', response.data?.message || 'Unknown error');
                }
            } catch (error) {
                errorToast("Failed to update meeting time");
                console.error('Error updating meeting time:', error);
                // show failed toast notification here
            }
        };

        // Handle clicking on empty calendar slots
        const onSelectSlot = ({ start, end }) => {
            const slotData = {
                start: moment(start).format('YYYY-MM-DDTHH:mm'),
                end: moment(end).format('YYYY-MM-DDTHH:mm'),
            };
            // setSelectedSlot({ start, end });
            setFormData(slotData);
            setAvailableRooms([]); // Reset available rooms
            setShowFormDialog(true);
            fetchAvailableRooms(slotData.start, slotData.end);
        };

        const fetchAvailableRooms = useCallback(async (startTime, endTime) => {
            try {
                if (!startTime || !endTime) {
                    setAvailableRooms([]);
                    return;
                }

                const response = await fetchDetailsContent(`api/room/available?start=${encodeURIComponent(startTime)}&end=${encodeURIComponent(endTime)}`);

                console.log("Available rooms response: ", response);
                if (response && response.data && response.data.rooms) {
                    const roomOptions = response.data.rooms.map(room => ({
                        value: room.id,
                        label: room.name
                    }));
                    setAvailableRooms(roomOptions);
                } else {
                    setAvailableRooms([]);
                }
            } catch (error) {
                console.error('Error fetching available rooms:', error);
                setAvailableRooms([]);
            }
        }, [fetchDetailsContent]);

        const formFields = useMemo(() => {
            const fields = [
            {
                name: 'name',
                label: 'Meeting Name',
                type: 'text',
                required: true,
                value: formData.name || '',
                setValue: (value) => setFormData(prev => ({ ...prev, name: value }))
            },
            
            {
                name: 'type',
                label: 'Meeting Type',
                type: 'select',
                required: true,
                col: 6,
                value: formData.type || '',
                setValue: (value) => {
                        setFormData(prev => ({ ...prev, type: value, venue: '', roomId: '' }));
                    },
                    values: meetingTypes.map(type => ({ value: type.name, label: type.name }))
            },
            {
                name: 'mode',
                label: 'Meeting Mode',
                type: 'select',
                required: true,
                col: 6,
                value: formData.mode || '',
                setValue: (value) => setFormData(prev => ({ ...prev, mode: value, venue: '', roomId: '' })),
                values: [
                    { value: 'physical', label: 'Physical' },
                    { value: 'virtual', label: 'Virtual' },
                ]
            }
            ];

            fields.push(
            {
                name: 'start',
                label: 'Start Time',
                type: 'datetime-local',
                required: true,
                value: formData.start || '',
                // min: moment().format('YYYY-MM-DDTHH:mm'),
                minDate: moment(),
                validate: (value) => {
                    if (!value) return true;
                    const selectedDate = moment(value);
                    const now = moment();
                    if (selectedDate.isBefore(now)) {
                        return "Start time cannot be in the past";
                    }
                    return true;
                },
                setValue: (value) => {
                    setFormData(prev => ({ ...prev, start: value }));
                    if (formData.end && value) {
                        fetchAvailableRooms(value, formData.end);
                    }
                },
                col: 6
            },
            {
                name: 'end',
                label: 'End Time',
                type: 'datetime-local',
                required: true,
                value: formData.end || '',
                // min: formData.start || moment().format('YYYY-MM-DDTHH:mm'),

                // minDate: formData.start || moment().format('YYYY-MM-DDTHH:mm'),
                minDate: formData['start'] ? moment(formData['start']) : null,

                validate: (value) => {
                    if (!value) return true;
                    if (!formData.start) {
                        return "Please select start time first";
                    }
                    const startDate = moment(formData.start);
                    const endDate = moment(value);
                    if (endDate.isBefore(startDate)) {
                        return "End time must be after start time";
                    }
                    if (endDate.isSame(startDate)) {
                        return "End time must be different from start time";
                    }
                    // if (startDate.format('YYYY-MM-DD') !== endDate.format('YYYY-MM-DD')) {
                    //     return "Meeting can't spent more than 12 hours";
                    // }
                    if (endDate.diff(startDate, 'hours', true) > 12) {
                        return "Meeting can't spent more than 12 hours";
                    }
                    return true;
                },
                setValue: (value) => {
                    setFormData(prev => ({ ...prev, end: value }));
                    if (formData.start && value) {
                        fetchAvailableRooms(formData.start, value);
                    }
                },
                col: 6
            },
            
            );
            // If meeting mode is 'virtual', show meeting link field
            if (formData.mode && formData.mode.toLowerCase() === 'virtual') {
                fields.push({
                    name: 'venue',
                    label: 'Meeting Link',
                    type: 'url',
                    required: true,
                    // col: 6,
                    placeholder: 'https://...',
                    value: formData.venue || '',
                    setValue: (value) => setFormData(prev => ({ ...prev, venue: value }))
                });
            }

            // If meeting type is 'external meetings', show venue field after type
            if (formData.type && formData.type.toLowerCase() === 'external meetings') {
                fields.push({
                    name: 'venue',
                    label: 'Venue',
                    type: 'text',
                    required: true,
                    value: formData.venue || '',
                    setValue: (value) => setFormData(prev => ({ ...prev, venue: value }))
                });
            }

            // Only show roomId if not external and mode is physical (not virtual)
            if ((!formData.type || formData.type.toLowerCase() !== 'external meetings') && 
                (!formData.mode || formData.mode.toLowerCase() !== 'virtual')) {
                fields.push({
                name: 'roomId',
                label: 'Meeting Room',
                type: 'select',
                required: true,
                value: formData.roomId || '',
                values: availableRooms.length > 0 ? availableRooms : [{ value: '', label: 'No Available Rooms This Time' }],
                setValue: (value) => setFormData(prev => ({ ...prev, roomId: value }))
            });
            }

            fields.push(
            {
                name: 'agenda',
                label: 'Agenda',
                type: 'textarea',
                rows: 5,
                required: false,
                value: formData.agenda || '',
                setValue: (value) => setFormData(prev => ({ ...prev, agenda: value }))
            },
            {
                name: "participants",
                label: "Participants",
                value: participants.map((r) => r.id).join(", "),
                required: true,
                col: 12,
                render: () => (
                    <TextField
                        fullWidth
                        value={participants.map((r) => r.names).join(", ")}
                        onClick={() => setIsSelectRecipientOpen(true)}
                        InputProps={{ readOnly: true }}
                        placeholder="Click to select Participants From Employee List"
                    />
                ),
                },
                {
                    name: "participants",
                    // label: "Other Participants",
                    render: () => (
                        <Box>
                            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
                                <Button variant="outlined" size="small"
                                    style={{ color: '#034A40', borderColor: '#034A40' }}

                                    onClick={() => openOtherModal()}>
                                    Add Other Participants
                                </Button>
                            </Box>

                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                {participants && participants.filter(p => p.isOther).map((p) => (
                                    <Chip
                                        key={p.id}
                                        label={p.names}
                                        onClick={() => openOtherModal(p)}
                                        onDelete={() => removeOtherParticipant(p.id)}
                                        sx={{ mr: 1, mb: 1 }}
                                    />
                                ))}
                                {participants && participants.filter(p => !p.isOther).length === 0 && participants.filter(p => p.isOther).length === 0 && (
                                    <Typography variant="caption" color="text.secondary">No other participants added</Typography>
                                )}
                            </Box>
                        </Box>
                    )
                }
            );
            return fields;
        }, [availableRooms, formData, fetchAvailableRooms, participants, meetingTypes]);

        const beforeSubmit = useCallback((data) => {
            const isExternal = data.type && data.type.toLowerCase() === 'external meetings';

            const employeeParticipantIds = participants.filter(p => !p.isOther).map(r => r.id);

            const otherParticipants = participants.filter(p => p.isOther).map(p => ({ id: p.id, names: p.names, phone: p.phone, email: p.email, category: p.category }));

            return {
                name: data.name,
                type: data.type,
                start: data.start,
                end: data.end,
                ...(isExternal
                    ? { venue: data.venue }
                    : { roomId: data.roomId }),
                agenda: data.agenda,

                participants: employeeParticipantIds,
                otherParticipants: otherParticipants
            };
        }, [participants]);

        const EventComponent = ({ event }) => {
            let duration = event.resource?.duration || 0;
            let durationInHours = 0;
            if (typeof duration === 'string') {
                const numericValue = parseFloat(duration.match(/\d+(\.\d+)?/)?.[0] || 0);
                if (duration.toLowerCase().includes('minute')) {
                    durationInHours = numericValue / 60;
                } else {
                    durationInHours = numericValue;
                }
            } else {
                durationInHours = duration;
            }
            return (
                <Tooltip
                    title={
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                {event.resource?.name}
                            </Typography>
                            <Typography variant="caption">
                                Room: {event?.Room?.name || event.resource?.venue || event?.venue}
                            </Typography>
                            <br />
                            <Typography variant="caption">
                                {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
                            </Typography>
                            <br />
                            <Typography variant="caption">
                                Status: {event.resource?.status || 'Scheduled'}
                            </Typography>
                            <br />
                            <Typography variant="caption">
                                Initiator: {event.resource?.createdBy ?
                                    `${event.resource.createdBy.firstName} ${event.resource.createdBy.lastName}` :
                                    'Unknown'}
                            </Typography>
                            <br />
                            <Typography variant="caption">
                                Participants: {event?.participants?.map(participant => participant.names).join(", ") || 'None'}
                            </Typography>
                        </Box>
                    }
                    arrow
                    placement="top"
                >

                    <Box sx={{
                        height: '100%',
                        p: 0.3,
                        background: 'linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255,255,255,0.2)',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease-in-out',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        }
                    }}>


                        <Typography variant="caption" sx={{
                            fontWeight: 'bold',
                            fontSize: '0.7rem',
                            color: '#333',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: 1.2,
                            mb: 0.2
                        }}>
                            {event.resource?.name}
                        </Typography>

                        {durationInHours > 1 && (
                            <Typography variant="caption" sx={{
                                fontWeight: 'bold',
                                fontSize: '0.7rem',
                                color: '#333',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                lineHeight: 1.2,
                                mb: 0.2
                            }}>
                                <RoomIcon sx={{ fontSize: '0.7rem', mr: 0.3, color: '#666', verticalAlign: 'middle' }} />
                                {event?.Room?.name || event.resource?.venue || event?.venue}
                            </Typography>
                        )}
                    </Box>

                </Tooltip>
            );
        };

        useEffect(() => {
            dataSummary()
        }, [dataSummary]);

        return (
            <>
                <Box sx={{ p: 2 }}>
                    <Box sx={calendarStyles}>
                        <DnDCalendar
                            localizer={localizer}
                            events={list}
                            step={30}
                            timeslots={2}
                            views={{
                                day: true,
                                week: true,
                                month: true,
                                // agenda: true
                            }}
                            defaultView="week"
                            defaultDate={new Date()}
                            style={{ height: height ?? 500 }}
                            startAccessor="start"
                            endAccessor="end"
                            firstDayOfWeek={1}
                            components={{
                                event: EventComponent,
                            }}
                            popup={false}
                            selectable
                            onSelectSlot={onSelectSlot}
                            onEventDrop={onEventDrop}
                            onEventResize={onEventResize}
                            resizable
                            draggableAccessor={() => true}
                            eventPropGetter={(event) => {
                                const colors = {
                                    'internal': {
                                        bg: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        border: '#667eea'
                                    },
                                    'pmo': {
                                        bg: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                                        border: '#f093fb'
                                    },
                                    'project': {
                                        bg: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                                        border: '#4facfe'
                                    },
                                    'default': {
                                        bg: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
                                        border: '#a8edea'
                                    }
                                };

                                const colorScheme = colors[event.resource?.type] || colors.default;

                                return {
                                    style: {
                                        background: colorScheme.bg,
                                        borderRadius: '8px',
                                        border: `2px solid ${colorScheme.border}`,
                                        color: 'white',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        overflow: 'visible',
                                        padding: '2px'
                                    }
                                };
                            }}
                            culture="en-GB"
                            onShowMore={(events, date) => {
                                setInfo({ events, date: moment(date).format('MMMM YYYY') })
                                setShowModal(true);
                            }}
                            onSelectEvent={(event) => {
                                setSelectedEvent(event);
                                setShowEventModal(true);
                            }}
                        />
                    </Box>
                </Box>

                <Dialog
                    onClose={() => setShowModal(false)}
                    open={showModal}
                    maxWidth="lg"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: '16px',
                            background: 'linear-gradient(135deg, #f0f8f7 0%, #e8f4f3 100%)',
                            backdropFilter: 'blur(20px)'
                        }
                    }}
                >
                    <DialogTitle sx={{
                        background: 'linear-gradient(135deg, #034A40 0%, #055B52 100%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2
                    }}>
                        <Schedule />
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
                            All Meetings for {info?.date}
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setShowModal(false)}
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.1)'
                                }
                            }}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>

                    <Box sx={{ p: 3 }}>
                        {info?.events && info.events.length > 0 ? (
                            <Box sx={{ display: 'grid', gap: 2 }}>
                                {info.events.map((event, index) => (
                                    <Card key={index} sx={{
                                        background: 'rgba(255, 255, 255, 0.95)',
                                        backdropFilter: 'blur(10px)',
                                        borderRadius: '12px',
                                        border: '1px solid rgba(102, 153, 152, 0.2)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 8px 25px rgba(3, 74, 64, 0.15)'
                                        }
                                    }}>
                                        <CardContent>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#034A40' }}>
                                                    {event.resource?.name}
                                                </Typography>
                                                <Chip
                                                    label={event.resource?.status || 'Scheduled'}
                                                    sx={{
                                                        backgroundColor: `${getStatusColor(event.resource?.status)}20`,
                                                        color: getStatusColor(event.resource?.status),
                                                        fontWeight: 500
                                                    }}
                                                />
                                            </Box>

                                            <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <RoomIcon sx={{ color: '#666', fontSize: '1.1rem' }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Room:</strong> {event.resource?.venue || event?.Room?.name || event.venue}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <AccessTime sx={{ color: '#666', fontSize: '1.1rem' }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Time:</strong> {moment(event.start).format('HH:mm')} - {moment(event.end).format('HH:mm')}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <EventAvailable sx={{ color: '#666', fontSize: '1.1rem' }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Type:</strong> {event.resource?.type || 'Meeting'}
                                                    </Typography>
                                                </Box>

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Person sx={{ color: '#666', fontSize: '1.1rem' }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Organizer:</strong> {event.resource?.createdBy ?
                                                            `${event.resource.createdBy.firstName} ${event.resource.createdBy.lastName}` :
                                                            'Unknown'}
                                                    </Typography>
                                                </Box>
                                                {/* Participant */}
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Person sx={{ color: '#666', fontSize: '1.1rem' }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        <strong>Participants:</strong> {event?.participants?.map(participant => participant.names).join(", ") || 'None'}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {event.resource?.agenda && (
                                                <>
                                                    <Divider sx={{ my: 2 }} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        {/* ignore the html tags in agenda */}
                                                        <span dangerouslySetInnerHTML={{ __html: event.resource.agenda }} />
                                                    </Typography>
                                                </>
                                            )}
                                        </CardContent>
                                    </Card>
                                ))}
                            </Box>
                        ) : (
                            <Typography variant="body1" sx={{ textAlign: 'center', py: 4, color: '#666' }}>
                                No meetings found for this date.
                            </Typography>
                        )}
                    </Box>
                </Dialog>

                {/* Individual Event Detail Modal */}
                <Dialog
                    onClose={() => setShowEventModal(false)}
                    open={showEventModal}
                    maxWidth="md"
                    fullWidth
                    PaperProps={{
                        sx: {
                            borderRadius: '16px',
                            background: 'linear-gradient(135deg, #f0f8f7 0%, #e8f4f3 100%)',
                            backdropFilter: 'blur(20px)'
                        }
                    }}
                >
                    <DialogTitle sx={{
                        // background: 'linear-gradient(135deg, #034A40 0%, #669998 100%)',
                        background: 'linear-gradient(135deg, #56677d 0%, #778391 100%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        borderRadius: '16px 16px 0 0'
                    }}>
                        <EventAvailable />
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
                            Meeting Details
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={() => setShowEventModal(false)}
                            sx={{
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.1)'
                                }
                            }}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>

                    <Box sx={{ p: 3 }}>
                        {selectedEvent && (
                            <Card sx={{
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '12px',
                                border: '1px solid rgba(102, 153, 152, 0.2)',
                            }}>
                                <CardContent sx={{ p: 3 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#034A40' }}>
                                            {selectedEvent.resource?.name}
                                        </Typography>
                                        <Chip
                                            label={selectedEvent.resource?.status || 'Scheduled'}
                                            sx={{
                                                backgroundColor: `${getStatusColor(selectedEvent.resource?.status)}20`,
                                                color: getStatusColor(selectedEvent.resource?.status),
                                                fontWeight: 500,
                                                fontSize: '0.8rem',
                                                height: '28px'
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 3, mb: 3 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <RoomIcon sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>

                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    {selectedEvent?.Room?.name && selectedEvent?.Room?.name !== "" ? "Room" : "Venue"}
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {selectedEvent?.Room?.name || selectedEvent.resource?.venue || "Unknown Room"}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <AccessTime sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    Time
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {moment(selectedEvent.start).format('MMM DD, YYYY')}
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary">
                                                    {moment(selectedEvent.start).format('HH:mm')} - {moment(selectedEvent.end).format('HH:mm')}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Schedule sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    Duration
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {(() => {
                                                        const diffMs = new Date(selectedEvent.end) - new Date(selectedEvent.start);
                                                        const totalMinutes = Math.floor(diffMs / 60000);
                                                        const hours = Math.floor(totalMinutes / 60);
                                                        const minutes = totalMinutes % 60;
                                                        let result = '';
                                                        if (hours > 0) result += `${hours} Hr${hours > 1 ? 's' : ''}`;
                                                        if (minutes > 0) result += `${hours > 0 ? ' ' : ''}${minutes} Min${minutes > 1 ? 's' : ''}`;
                                                        if (!result) result = '0 Mins';
                                                        return result;
                                                    })()}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <EventAvailable sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    Type
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500, textTransform: 'capitalize' }}>
                                                    {selectedEvent.resource?.type || 'Meeting'}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Person sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    Organizer
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {selectedEvent.resource?.createdBy ?
                                                        `${selectedEvent.resource.createdBy.firstName} ${selectedEvent.resource.createdBy.lastName}` :
                                                        'Unknown'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <Person sx={{ color: '#669998', fontSize: '1.3rem' }} />
                                            <Box>
                                                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                                                    Participants
                                                </Typography>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {selectedEvent?.participants?.map(participant => participant.names).join(", ") || 'None'}
                                                </Typography>
                                            </Box>

                                        </Box>
                                    </Box>

                                    {selectedEvent.resource?.agenda && (
                                        <>
                                            <Divider sx={{ my: 2 }} />
                                            <Box>
                                                <Typography variant="h6" sx={{ mb: 1, color: '#034A40', fontWeight: 600 }}>
                                                    Agenda
                                                </Typography>
                                                <Typography variant="body1" sx={{
                                                    lineHeight: 1.6,
                                                    backgroundColor: '#f4f9f8',
                                                    p: 2,
                                                    borderRadius: '8px',
                                                    border: '1px solid #d0e8e6'
                                                }}>
                                                    <span dangerouslySetInnerHTML={{ __html: selectedEvent.resource.agenda }} />
                                                </Typography>
                                            </Box>
                                        </>
                                    )}
                                </CardContent>
                            </Card>
                        )}
                    </Box>
                </Dialog>

                <FormDialog
                    open={showFormDialog}
                    setOpen={setShowFormDialog}
                    title="Create New Meeting"
                    fields={formFields}
                    url="api/meeting/schedule"
                    beforeSubmit={beforeSubmit}
                    onSuccess={() => {
                        setShowFormDialog(false);
                        // setSelectedSlot(null);
                        setAvailableRooms([]);
                        setFormData({});
                        setParticipants([]);
                        dataSummary(); // Refresh the calendar
                    }}
                    buttonTitle="Create Meeting"
                    maxWidth="md"
                />

                {/* Add / Edit Other Participant Modal */}
                <FormDialog
                    title={otherEditObject ? "Edit Participant" : "Add New Participant"}
                    open={otherOpen}
                    setOpen={setOtherOpen}
                    fields={[
                        {
                            name: "names",
                            value: otherForm.names,
                            label: "Names",
                            required: true,
                            setValue: (val) => setOtherForm(prev => ({ ...prev, names: val })),
                        },
                        {
                            name: "phone",
                            type: "tel",
                            value: otherForm.phone,
                            label: "Phone Number",
                            setValue: (val) => setOtherForm(prev => ({ ...prev, phone: val }))
                        },
                        {
                            name: "email",
                            type: "email",
                            value: otherForm.email,
                            label: "Email Address",
                            required: true,
                            setValue: (val) => setOtherForm(prev => ({ ...prev, email: val }))
                        },
                        {
                            name: "title",
                            type: "text",
                            value: otherForm.category,
                            label: "Title",
                            setValue: (val) => setOtherForm(prev => ({ ...prev, category: val }))
                        },
                    ]}
                    beforeSubmit={(event) => {
                        // FormDialog will provide the event object with values; pass to submitOtherParticipant
                        // event will include keys: names, phone, email, title
                        submitOtherParticipant(event);
                    }}
                />

                <SelectEmployee
                    open={isSelectRecipientOpen}
                    onClose={() => setIsSelectRecipientOpen(false)}
                    confirm={handleSelectRecipients}
                    selectedEmployees={participants}
                    resources={employees}
                    settings={{ backgroundColorPrimary: "#054163" }}
                />
            </>
        );
    };

export default ViewAllRoomsCalendar;
// export default connect(mapStateToProps, mapDispatchToProps)(ViewAllRoomsCalendar);

